import React, { Component } from "react";
import "../public/assets/vendor/fonts/fontawesome.css";
import "../public/assets/vendor/fonts/flag-icons.css";
import "../public/assets/vendor/css/rtl/core.css";
import "../public/assets/vendor/css/rtl/theme-default.css";
import "../public/assets/css/demo.css";
import "../public/assets/vendor/libs/perfect-scrollbar/perfect-scrollbar.css";
import "../public/assets/vendor/libs/typeahead-js/typeahead.css";
import "../public/assets/vendor/libs/datatables-bs5/datatables.bootstrap5.css";
import "../public/assets/vendor/libs/datatables-responsive-bs5/responsive.bootstrap5.css";
import "../public/assets/vendor/libs/datatables-checkboxes-jquery/datatables.checkboxes.css";
import logo from "../../../assets/img/givbeeLogo.png";
import dpTextLogo from "../../../assets/img/dptextLogo.png";
import eventTextLogo from "../../../assets/img/eventTextLogo.jpeg";
import "./Navbar.css";
import { withRouter } from "../../../withRouter";
import staticDataAction from "../../../redux/staticData/staticDataAction";
import headerAction from "../../../redux/header/headerAction";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import AppUserDataAction from "../../../redux/appUserData/AppUserDataAction";
// import { connect } from "react-redux";
import Utils from "../../../provider/Utils";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import { NavLink } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import ActiveMenuAction from "../../../redux/activeMenu/ActiveMenuAction";
import { LogOut_Url } from "../../../provider/ServiceUrl";
import SelectedTabAction from "../../../redux/selectedTab/SelectedTabAction";
import SelectedDomainAction from "../../../redux/selectedDomain/SelectedDomainAction";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
import AccountSettingDataAction from "../../../redux/accountSetting/AccountSettingDataAction";
import CrmIntegrationAction from "../../../redux/crmIntegration/CrmIntegrationAction";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";
import { Menu, MenuItem, IconButton, Avatar } from "@mui/material";
import AppleStore from "../../../assets/img/appleStore.png";
import GooglePlayStore from "../../../assets/img/googlePlayStore.png";
import AppleStoreQRCode from "../../../assets/img/GivBeeAppleStoreQRCode.png";
import AndroidStoreQRCode from "../../../assets/img/GivBeeAndroidStoreQRCode.png";
import OveragesLockIcon from "../../../assets/img/overagesLock.png";
import AlertIcon from "../../../assets/img/alertIcon.png";
import UsecaseDialog from "../dialogContent/UsecaseDialog";
import PaginationRowAction from "../../../redux/paginationRow/PaginationRowAction";
import LogoutIcon from '@mui/icons-material/Logout';
import PtsAlert from "../ptsAlert/PtsAlert";

class Navbar extends Component {
  header = store.getState().header.header;
  appuser = store.getState().appUserData.appUserData.appuser;
  tollfreeNumber = store.getState().appUserData.tollfreeNumber;
  tollFreeNumberStatus =
    store.getState().appUserData.tollFreeNumberStatus;
  smsCredits = store.getState().appUserData.smsCredits;
  companyName = store.getState().appUserData?.organizationDetails?.name;
  organizationPlan = store.getState().appUserData?.organizationDetails?.plan;
  logoData = store.getState().appUserData.logoData.logo;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  topMenus = store.getState().appUserData.appUserData.appuser?.profile?.menus;
  TandCPrivacyPolicyAccpted =
    store.getState().appUserData.appUserData.appuser
      ?.isTandCPrivacyPolicyAccpted;
  cardExpired = store.getState().appUserData.appUserData?.isCardExpired;
  CardExpiring = store.getState().appUserData.appUserData?.isCardExpiring;
  hasActiveSubscription = store.getState().appUserData?.hasActiveSubscription;
  tollfreeNumberPurchased =
    store.getState().appUserData.appUserData.isTollfreeNumberPurchased;
  tollFreeNumberError =
    store.getState().appUserData.appUserData.tollFreeNumberError;
  hasActiveCard = store.getState().appUserData.smsCredits?.hasActiveCard;
  showCardexpiryMessage = store.getState().appUserData.smsCredits?.showCardexpiryMessage;
  planType = store.getState().appUserData.appUserData.planType?.type;
  crmIntegration = store.getState().crmIntegration.crmIntegration;
  accountSettings = store.getState().accountSetting?.accountSetting;

  constructor(props) {
    super(props);

    let userMenuArray = this.topMenus;
    let activeMenu = store.getState().activeMenu.activeMenu;
    if (undefined === activeMenu || null === activeMenu) {
      activeMenu =
        (userMenuArray && userMenuArray.length) > 0 ? userMenuArray[0].id : -1;
    }
    let showTnCModal = false;
    let showCardExpiredModal = false;
    let showCardExpiringModal = false;
    let showHasActiveCard = false;
    let openAddCreditCard = false;
    let scrollTo = "";

    if (props.state) {
      openAddCreditCard = props.state.openAddCreditCard;
      scrollTo = props.state.scrollTo;
    }
    if (
      this.TandCPrivacyPolicyAccpted === false &&
      this.crmIntegration === BUSINESS_DOMAIN.dpText
    ) {
      showTnCModal = true;
    } else if (
      this.cardExpired === true &&
      openAddCreditCard === false &&
      scrollTo === ""
    ) {
      showCardExpiredModal = true;
      showHasActiveCard = false;
      showCardExpiringModal = false;
    } else if (this.CardExpiring === true && openAddCreditCard === false) {
      showCardExpiringModal = true;
      showHasActiveCard = false;
      showCardExpiredModal = false;
    } else if (
      !this.cardExpired &&
      !this.CardExpiring &&
      this.showCardexpiryMessage &&
      this.crmIntegration === BUSINESS_DOMAIN.dpText &&
      openAddCreditCard === false
    ) {
      showHasActiveCard = true;
      showCardExpiredModal = false;
      showCardExpiringModal = false;
    }

    this.state = {
      sidebarMenu: userMenuArray,
      companyLogo: this.logoData ? this.logoData : "",
      openTnCModal: showTnCModal,
      openCardExpiredModal: showCardExpiredModal,
      openCardExpiringModal: showCardExpiringModal,
      openHasActiveSubscription: this.hasActiveSubscription,
      openHasActiveCard: showHasActiveCard,
      istollfreeNumberPurchased: false,
      hasNavigatedAfterLogin: false,
      downloadAppOpen: false,
      menuList: false,
      unverifiedOpen: false,
      stopCardExpiryMessage: false,
      openOverages: false,
      sendRemoveOverageLimitOpen: false,
      open: false,
    };
  }


  componentDidMount() {
    // Initial value
    const state = store.getState();

    this.tollfreeNumber = state.appUserData.tollfreeNumber;
    this.tollFreeNumberStatus = state.appUserData.tollFreeNumberStatus;

    // Subscribe to Redux updates
    this.unsubscribe = store.subscribe(() => {
      const updatedState = store.getState();

      this.tollfreeNumber = updatedState.appUserData.tollfreeNumber;
      this.tollFreeNumberStatus =
        updatedState.appUserData.tollFreeNumberStatus;

      this.forceUpdate(); //required to reflect UI changes
    });
  }

  profileHandler = (e) => {
    store.dispatch(ActiveMenuAction.setActiveMenu("/profile"));
    this.props.navigate("/profile", {});
    this.setState({ anchorElUser: false });
  };

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  // goToPage = (e, id, pageid) => {
  //   let tollfreeNumberPurchased =
  //     store.getState().appUserData.appUserData.isTollfreeNumberPurchased;
  //   if (tollfreeNumberPurchased === false && this.header?.isAp !== true) {
  //     this.setState({ istollfreeNumberPurchased: true }, () => {
  //       if (this.usecaseDialogueRef?.current) {
  //         this.usecaseDialogueRef.current.handleOpen();
  //       }
  //     });
  //   } else {
  //     this.props.navigate(pageid);
  //   }
  // };

  goToPage = (e, id, pageid) => {
    // if (!this.state.hasNavigatedAfterLogin) {
    //   let tollfreeNumberPurchased =
    //     store.getState().appUserData.appUserData.isTollfreeNumberPurchased;

    //   if (tollfreeNumberPurchased === false && this.header?.isAp !== true) {
    //     this.setState({ istollfreeNumberPurchased: true }, () => {
    //       if (this.usecaseDialogueRef?.current) {
    //         this.usecaseDialogueRef.current.handleOpen();
    //       }
    //     });
    //   } else {
    //     this.props.navigate(pageid);
    //   }
    //   this.setState({ hasNavigatedAfterLogin: true });
    // } else {
    this.props.navigate(pageid);
    // }
  };

  getChildMenus = (e, id, pageid) => {
    this.goToPage(e, id, pageid);
    for (let i = 0; i < this.state.sidebarMenu.length; i++) {
      if (this.state.sidebarMenu[i].id === id) {
        store.dispatch(ActiveMenuAction.setActiveMenu(id));
        this.setState({ activeMenu: id });
      }
    }

    for (
      let i = 0;
      this.state.sidebarMenu && i < this.state.sidebarMenu.length;
      i++
    ) {
      if (this.activeMenu === pageid) {
        store.dispatch(ActiveMenuAction.setActiveMenu(pageid));
        this.setState({ activeMenu: pageid });
        this.state.sidebarMenu[i].isActive = true;
      } else {
        if (this.state.sidebarMenu[i].id === id) {
          store.dispatch(ActiveMenuAction.setActiveMenu(pageid));
          this.setState({ activeMenu: pageid });
          this.state.sidebarMenu[i].isActive = true;
        } else {
          this.state.sidebarMenu[i].isActive = false;
        }
      }
    }
  };

  logOut = () => {
    let postObject = {
      header: this.header,
      appuser: {
        email: this.appuser?.email,
      },
    };
    FetchServerData.callPostService(LogOut_Url, postObject).then((output) => {
      if (output.status === "SUCCESS") {
        store.dispatch(staticDataAction.setStaticData({}));
        store.dispatch(headerAction.setHeader({}));
        store.dispatch(AppUserDataAction.setUserData({}));
        store.dispatch(AppUserDataAction.setLogo({}));
        store.dispatch(ActiveMenuAction.setActiveMenu({}));
        store.dispatch(SelectedTabAction.setSelectedTab(""));
        store.dispatch(SelectedDomainAction.setSelectedDomain(""));
        store.dispatch(SelectedDomainAction.setEventState({}));
        store.dispatch(AccountSettingDataAction.setAccountSettingData({}));
        store.dispatch(CrmIntegrationAction.setCrmIntegration(""));
        store.dispatch(PaginationRowAction.setSmsMessagesPaginationState({}));
        store.dispatch(PaginationRowAction.setSendHistoryPaginationState({}));
        store.dispatch(PaginationRowAction.setSheduledSendPaginationState({}));
        store.dispatch(PaginationRowAction.setOptinsPaginationState({}));
        store.dispatch(PaginationRowAction.setPaindingPaginationState({}));
        store.dispatch(PaginationRowAction.setOptoutPaginationState({}));
        store.dispatch(PaginationRowAction.setInvalidPaginationState({}));
        store.dispatch(PaginationRowAction.succSendMsgStatsPaginationState({}));
        store.dispatch(PaginationRowAction.textResponseMsgStatsPaginationState({}));
        store.dispatch(PaginationRowAction.paymentShortLinkPaginationState({}));

        this.setState({ anchorElUser: false });
        if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
          localStorage.removeItem("dptextGmailHeader");
          localStorage.removeItem("dptextHeader");
          localStorage.removeItem("dptextUserId");
          localStorage.removeItem("dptextPassword");
          localStorage.removeItem("dptextSelectedOption");
          localStorage.removeItem("dptextRememberMe");
          this.props.navigate("/dptextSignin");
        } else {
          localStorage.clear();
          localStorage.removeItem("gmailHeader");
          localStorage.removeItem("header");
          localStorage.removeItem("userId");
          localStorage.removeItem("password");
          localStorage.removeItem("selectedOption");
          localStorage.removeItem("rememberMe");
          this.props.navigate("/signin");
        }
      } else {
      }
    });
  };

  menuListToggle = () => {
    this.setState({
      menuList: !this.state.menuList,
      activeElement: "",
    });
  };

  openMenu() {
    this.setState({
      menuList: true,
    });
  }
  navigateToLink(linkToNavigate) {
    this.setState({
      activeElement: linkToNavigate,
    });
    this.props.navigate(linkToNavigate);
  }
  openLoginTab = () => {
    const win = window.open("/signin", "_blank");
    win.focus();
  };
  handleClose = (e) => {
    e.stopPropagation(); // <-- prevent further bubbling of click event
    this.setState({
      menuList: false,
    });
  };

  organizationInfo() {
    this.setState({
      open: false,
    });
    store.dispatch(ActiveMenuAction.setActiveMenu("/settings"));
    store.dispatch(SelectedTabAction.setSelectedTab(0));

    this.props.navigate("/settings", {
      state: {
        pageId: "OrgLogo",
        action: "view",
      },
    });
  }
  handleDialogboxOpen() {
    this.setState({
      open: true,
    });
  }
  handleDialogboxClose() {
    this.setState({
      open: false,
    });
  }

  handleCloseUserMenu = () => {
    this.setState({ anchorElUser: false });
  };

  handleOpenUserMenu = (event) => {
    this.setState({
      anchorElUser: event.currentTarget,
    });
  };

  tollfreeNumberPurchasedToggle() {
    this.setState({ istollfreeNumberPurchased: false });
  }
  addTollFreeNumberModal() {
    this.setState({
      istollfreeNumberPurchased: false,
    });
    store.dispatch(SelectedTabAction.setSelectedTab(1));

    this.props.navigate("/settings");
  }

  handleTAndCClickCheckBox = (e) => {
    this.setState({
      checkboxTNC: e.target.checked,
    });
  };
  handleTAndCClickLable = () => {
    this.setState({
      checkboxTNC: !this.state.checkboxTNC,
    });
  };

  acceptTandCtInBackend(e) {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService("/appuserms/acceptTandC", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let userDetails = output.data;

          // Update Redux
          store.dispatch(AppUserDataAction.setUserData(userDetails));

          // Close T&C modal
          this.setState({ openTnCModal: false }, () => {
            if (this.cardExpired === true) {
              this.setState({ openCardExpiredModal: true });
            } else if (
              this.showCardexpiryMessage &&
              this.crmIntegration === BUSINESS_DOMAIN.dpText
            ) {
              this.setState({ openHasActiveCard: true });
            }
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  tnCModalToggle = () => {
    let postObject = {
      header: this.header,
      appuser: {
        email: this.appuser?.email,
      },
    };
    FetchServerData.callPostService(LogOut_Url, postObject).then((output) => {
      if (output.status === "SUCCESS") {
        store.dispatch(staticDataAction.setStaticData({}));
        store.dispatch(headerAction.setHeader({}));
        store.dispatch(AppUserDataAction.setUserData({}));
        store.dispatch(AppUserDataAction.setLogo({}));
        store.dispatch(ActiveMenuAction.setActiveMenu({}));
        store.dispatch(SelectedTabAction.setSelectedTab(""));
        store.dispatch(SelectedDomainAction.setSelectedDomain(""));
        store.dispatch(SelectedDomainAction.setEventState({}));
        store.dispatch(AccountSettingDataAction.setAccountSettingData({}));
        store.dispatch(CrmIntegrationAction.setCrmIntegration(""));

        if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
          localStorage.removeItem("dptextUserId");
          localStorage.removeItem("dptextPassword");
          localStorage.removeItem("dptextSelectedOption");
          localStorage.removeItem("dptextRememberMe");
          this.props.navigate("/dptextSignin");
        } else {
          localStorage.clear();
          localStorage.removeItem("userId");
          localStorage.removeItem("password");
          localStorage.removeItem("selectedOption");
          localStorage.removeItem("rememberMe");
          this.props.navigate("/signin");
        }
      } else {
      }
    });
  };

  cardExpiredCancel() {
    this.setState({
      openCardExpiredModal: false,
    });
  }
  cardExpiringCancel() {
    this.setState({
      openCardExpiringModal: false,
    });
  }
  hasActiveSubscriptionCancel() {
    this.setState({
      openHasActiveSubscription: false,
    });
  }
  handleUnverifiedOpen = () => {
    this.setState({
      unverifiedOpen: true,
    });
  };
  handleUnverifiedClose() {
    this.setState({
      unverifiedOpen: false,
    });
  }

  goBillingTab(e, openAddCreditCard) {
    e.preventDefault();
    this.setState({
      openHasActiveCard: false,
      openCardExpiredModal: false,
      openCardExpiringModal: false,
      openHasActiveSubscription: false,
      openCreditUsage: false,
    });

    if (this.header.isAp) {
      store.dispatch(SelectedTabAction.setSelectedTab(2));
    } else {
      store.dispatch(SelectedTabAction.setSelectedTab(1));
    }

    store.dispatch(ActiveMenuAction.setActiveMenu("/settings"));
    this.props.navigate("/settings", {
      state: {
        openAddCreditCard: openAddCreditCard,
        showHasActiveCard: false,
      },
    });
  }

  handleUpdateCardClick = () => {
    this.setState({
      openCardExpiredModal: false,
    });
    if (this.header.isAp) {
      store.dispatch(SelectedTabAction.setSelectedTab(2));
    } else {
      store.dispatch(SelectedTabAction.setSelectedTab(1));
    }
    store.dispatch(ActiveMenuAction.setActiveMenu("/settings"));
    this.props.navigate("/settings", {
      state: { scrollTo: "savedCreditCards" },
    });
  };

  redirectLinkToInsights() {
    store.dispatch(ActiveMenuAction.setActiveMenu("/analytics"));
    this.props.navigate("/analytics");
  }
  handleDownloadAppDialogOpen() {
    this.setState({
      downloadAppOpen: true,
    });
  }
  handleDownloadAppDialogClose() {
    this.setState({
      downloadAppOpen: false,
    });
  }
  hasActiveCardCancel() {
    const smsCredits = {
      ...this.smsCredits,
      showCardexpiryMessage: false
    };
    store.dispatch(AppUserDataAction.setUsage(smsCredits));
    this.setState({
      openHasActiveCard: false,
    });
  }

  handleOpenCreditUsage = (event) => {
    this.setState({
      openCreditUsage: true,
      anchorEl: event.currentTarget
    });
  };
  handleOpenOverages = (event) => {
    this.setState({
      openOverages: true,
      overagesAnchorEl: event.currentTarget
    });
  };
  handleCloseOverages = (event) => {
    this.setState({
      openOverages: false,
      overagesAnchorEl: null,
    });
  };

  handleCloseCreditUsage = () => {
    this.setState({
      openCreditUsage: false,
      anchorEl: null
    });
  };

  goToHomePage(pageid) {
    store.dispatch(ActiveMenuAction.setActiveMenu(pageid));
    this.props.navigate(pageid);
  }
  handleStopCardExpiryMessageChange = () => {
    this.setState({ stopCardExpiryMessage: true })
    this.stopCardExpiryMessageToBackend()
  }

  stopCardExpiryMessageToBackend() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService("/appuserms/stopCardExpiryMessage", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          const smsCreditDetais = output.data.smsCredits;
          store.dispatch(AppUserDataAction.setUsage(smsCreditDetais));
          this.setState({ openHasActiveCard: false })
        } else {
        }
      })
      .catch((error) => { });
  }
  handleUsecaseDialogue() {
    store.dispatch(ActiveMenuAction.setActiveMenu("/settings"));
    this.props.navigate("/settings");
    store.dispatch(SelectedTabAction.setSelectedTab(1));
  }


  sendRemoveOverageLimitToBackend() {
    this.setState({
      openOverages: false,
      overagesAnchorEl: null,
    });
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(
      "/appuserms/sendRemoveOverageLimitToSupport",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success("An email is send to support team. Someone will contact you soon.");
        } else {
        }
      })
      .catch((error) => { });
  }

  handleCloseSendRemoveOverageLimit() {
    this.setState({
      sendRemoveOverageLimitOpen: false
    })
  }

  render() {
    this.usecaseDialogueRef = React.createRef();
    // let logoData = store.getState().appUserData.logoData.logo;
    // let companyName = store.getState().appUserData?.organizationDetails?.name;
    let userName = `${this.appuser?.firstName} ${this.appuser?.lastName}`;
    let activeMenu = store.getState().activeMenu.activeMenu;
    let smsCredits = store.getState().appUserData.smsCredits;
    for (
      let i = 0;
      this.state.sidebarMenu && i < this.state.sidebarMenu.length;
      i++
    ) {
      if (this.state.sidebarMenu[i].pageid === activeMenu) {
        this.state.sidebarMenu[i].isActive = true;
      } else {
        this.state.sidebarMenu[i].isActive = false;
      }
    }
    return (
      <>
        <nav
          className="layout-navbar navbar navbar-expand-xl align-items-center bg-navbar-theme position-sticky top-0 pb-0"
          id="layout-navbar"
          style={{ width: "100%", zIndex: "1000" }}
        >
          {this.businessDomain === BUSINESS_DOMAIN.eventText && (
            <div
              className="navbar-brand app-brand demo d-none d-xl-flex py-0"
              style={{ width: "185px", justifyContent: "end" }}
            >
              {/* <a
                href="/eventMgmt"
                target="_self"
                className="app-brand-link gap-2"
              > */}
              <span
                className="app-brand-logo demo"
                onClick={(e) => this.goToHomePage("/eventMgmt")}
              >
                <img src={eventTextLogo} style={{ width: "120px" }} alt="" />
              </span>
              {/* </a> */}
            </div>
          )}
          <div className="container-xxl align-self-end overflow-auto">
            {this.businessDomain !== BUSINESS_DOMAIN.eventText && (
              <div className="navbar-brand app-brand demo d-none d-xl-flex py-0 pb-2 me-4">
                {/* <a
                  href="/messages"
                  target="_self"
                  className="app-brand-link gap-2"
                > */}
                <span
                  className="app-brand-logo demo"
                  onClick={(e) => this.goToHomePage("/messages")}
                >
                  {this.businessDomain === BUSINESS_DOMAIN.givbeeMain && (
                    <img
                      src={logo}
                      style={{ width: "90px", marginLeft: "4px" }}
                      alt=""
                    />
                  )}
                  {this.businessDomain === BUSINESS_DOMAIN.dpText && (
                    <img
                      src={
                        this.businessDomain === BUSINESS_DOMAIN.dpText
                          ? dpTextLogo
                          : logo
                      }
                      style={{ width: "90px" }}
                      alt=""
                    />
                  )}
                  {/* {this.businessDomain === BUSINESS_DOMAIN.eventText && (
                    <img
                      src={eventTextLogo}
                      style={{ width: "120px" }}
                      alt=""
                    />
                  )} */}
                </span>
                {/* </a> */}
                <a
                  href="javascript:void(0);"
                  className="layout-menu-toggle menu-link text-large ms-auto d-xl-none"
                >
                  <i className="bx bx-chevron-left bx-sm align-middle" />
                </a>
              </div>
            )}
            <div
              className="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none"
              // onClick={this.toggleSidebar}
              onClick={(e) => this.openMenu()}
            >
              <a
                className="nav-item nav-link px-0 me-4-xl"
                href="javascript:void(0)"
              >
                <i className="bx bx-menu bx-sm" />
              </a>
            </div>
            <div className="row d-flex mt-3" style={{ width: "100%" }}>
              <div className="col-md-12" style={{ textAlign: "center" }}>
                <ul
                  className="menu-inner tabSetting ms-4 overflow-auto"
                  style={{
                    backgroundColor: "#fff",
                    // padding: "6px 0px",
                    width: "100%",
                  }}
                >
                  {/* Dashboards */}
                  {this.state.sidebarMenu
                    ?.sort((a, b) => a.displaysequence - b.displaysequence)
                    .map((menu, index) => {
                      if (!this.isEmpty(menu)) {
                        // let isactive = false;
                        // if (menu.id === this.state.activeMenu) {
                        //   isactive = true;
                        // }
                        return menu.isactive === true ? (
                          <span>
                            <li
                              className={
                                menu.isActive
                                  ? "menu-item m-0"
                                  : "menu-item m-0 horizontal-menu-link"
                              }
                              style={{
                                borderBottom: menu.isActive
                                  ? "3px solid #005476"
                                  : "none",
                                height: "35px",
                              }}
                              onClick={(e) =>
                                this.getChildMenus(e, menu.id, menu.pageid)
                              }
                              key={index}
                            >
                              <NavLink
                                to={menu.pageid}
                                // className="menu-link"
                                style={{
                                  // background: menu.isActive ? "#cde6ff9c" : "",
                                  color: menu.isActive ? "#005476" : "#353538",
                                  // borderRadius: "10px",
                                  padding: "4px 15px",
                                  fontSize: "16px",
                                  marginLeft: "0em",
                                  // borderBottom: menu.isActive
                                  //   ? "3px solid #005476"
                                  //   : "none",
                                }}
                                key={index}
                                // onSelect={this.selectedChildMenu.bind(this)}
                                onClick={(e) =>
                                  this.getChildMenus(e, menu.id, menu.pageid)
                                }
                              >
                                {/* // <a href="/message" className="menu-link"> */}
                                <div data-i18n="Dashboards">{menu.uiname}</div>
                              </NavLink>
                            </li>
                          </span>
                        ) : (
                          <div></div>
                        );
                      }
                    })}
                </ul>
              </div>
              {/* <div className="col-sm-4 align-self-center">
                <a
                  style={{ color: "#fff", cursor: "pointer" }}
                  href="https://apps.apple.com/us/app/family-care-circle/id1602521967"
                  target="_blank"
                >
                  <img
                    src={AppleStore}
                    style={{
                      height: "40px",
                      border: "1px solid white",
                      borderRadius: "5px",
                      marginBottom: "20px",
                    }}
                  />
                </a>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <a
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.familycarecircle.fccmobileapp"
                  style={{ color: "#fff", cursor: "pointer" }}
                >
                  <img
                    src={GooglePlayStore}
                    style={{
                      height: "40px",
                      border: "1px solid white",
                      borderRadius: "5px",
                    }}
                  />
                </a>
              </div> */}
            </div>
            <div
              className="navbar-nav-right d-flex align-items-center pb-2"
            // id="navbar-collapse"
            >
              <ul className="navbar-nav flex-row align-items-center ms-auto">
                <>
                  <li className="nav-item navbar-search-wrapper me-2 align-self-end">
                    {this.tollfreeNumber === null && (
                      <>
                        <span
                          style={{
                            color: "#990000",
                            fontWeight: "700",
                            cursor: "pointer",
                            fontSize: "12px",
                          }}
                          onClick={this.handleUsecaseDialogue.bind(this)}
                        >
                          <u>Complete set-up now.</u>
                        </span>
                        <br></br>
                      </>
                    )}
                    {this.tollFreeNumberStatus === "Rejected" && (
                      <>
                        <span
                          style={{
                            color: "#990000",
                            fontWeight: "700",
                            cursor: "pointer",
                            fontSize: "12px",
                          }}
                          onClick={this.handleUsecaseDialogue.bind(this)}
                        >
                          <u>Attention needed.</u>
                        </span>
                        <br></br>
                      </>
                    )}
                    {this.businessDomain === BUSINESS_DOMAIN.eventText && (
                      <span
                        className="anchortag"
                        onClick={this.handleDownloadAppDialogOpen.bind(this)}
                      >
                        <u>Download the App!</u>
                      </span>
                    )}
                  </li>
                </>

                <li className="nav-item navbar-search-wrapper me-1 align-self-end">
                  {/* <Tooltip
                    title={`Outgoing: ${smsCredits?.outgoingCredits} / Incoming: ${smsCredits?.incomingCredits}`}
                    classes={{
                      popper: "custom-tooltip",
                    }}
                  > */}
                  <span className="smsCredits">
                    {this.tollfreeNumber !== null &&
                      this.tollfreeNumber !== undefined ? (
                      <>
                        <p className="mb-0" style={{ fontSize: "12px" }}>
                          <>
                            Text #:
                            <strong className="ms-1">
                              {Utils.viewTollFreeNumberFormate(
                                this.tollfreeNumber
                              ).slice(-12)}
                            </strong>
                            {this.tollFreeNumberStatus !== "Verified" &&
                              this.tollFreeNumberStatus !== "Approved" && (
                                <span
                                  style={{
                                    color: "#990000",
                                    fontWeight: "700",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => this.handleUnverifiedOpen(e)}
                                >
                                  &nbsp; - {Utils.equalsIgnoreCase(
                                    this.tollFreeNumberStatus,
                                    "Pending"
                                  ) ? "Pending" : "Unverified"}
                                </span>
                              )}
                          </>
                        </p>
                      </>
                    ) : (
                      ""
                    )}
                    {!(
                      this.businessDomain === BUSINESS_DOMAIN.eventText &&
                      Utils.equalsIgnoreCase(this.planType, "Onetime")
                    ) && (
                        < p style={{ fontSize: "12px", marginBottom: "0px" }}>
                          {smsCredits !== null && smsCredits !== undefined ? (
                            <>
                              {(this.hasActiveCard === false && this.crmIntegration === BUSINESS_DOMAIN.dpText) && (
                                <span
                                  className="me-1 cursor-pointer"
                                  onMouseEnter={this.handleOpenCreditUsage}
                                >
                                  <img
                                    src={AlertIcon}
                                    style={{ height: "10px", marginBottom: "2px", cursor: "pointer", color: "#566a7f" }}
                                    alt="alert"
                                  />
                                </span>
                              )}
                              Credits used:
                              <strong className="ms-1">
                                {Utils.formatWithCommas(
                                  smsCredits?.consumedCredits
                                )}
                                /
                                {this.hasActiveCard === false &&
                                  this.crmIntegration === BUSINESS_DOMAIN.dpText ? (
                                  <span
                                    style={{
                                      color: "#990000",
                                      fontWeight: "700",
                                      cursor: "pointer",
                                    }}
                                    onClick={this.handleOpenCreditUsage}
                                  >
                                    {Utils.formatWithCommas(
                                      smsCredits?.availableCredits
                                    )}
                                  </span>
                                ) : (
                                  Utils.formatWithCommas(
                                    smsCredits?.availableCredits
                                  )
                                )}
                              </strong>
                              {(this.businessDomain !== BUSINESS_DOMAIN.eventText && !this.accountSettings?.enableOverages) &&
                                <span
                                  className="ms-1 cursor-pointer"
                                  onMouseEnter={this.handleOpenOverages}
                                >
                                  <img src={OveragesLockIcon}
                                    style={{
                                      height: "10px",
                                      marginBottom: "2px",
                                      color: "#566a7f"
                                    }}
                                  />
                                </span>
                              }
                            </>
                          ) : (
                            ""
                          )}
                        </p>
                      )}
                  </span>
                  {/* </Tooltip> */}
                </li>
                <li className="nav-item navbar-search-wrapper me-xl-0">
                  <IconButton onClick={(e) => this.handleOpenUserMenu(e)}>
                    <Avatar
                      sx={{
                        bgcolor: "#337ab7",
                        color: "#fff",
                        width: 35,
                        height: 35,
                        fontSize: 16,
                        fontWeight: "500",
                      }}
                    >
                      {Utils.getShortName(userName)}
                    </Avatar>
                  </IconButton>
                </li>
              </ul>
            </div>
          </div>
        </nav >
        <Menu
          className="userMenu"
          sx={{ mt: "40px", zIndex: "10000" }}
          id="menu-appbar"
          anchorEl={this.state.anchorElUser}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          // keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(this.state.anchorElUser)}
          onClose={this.handleCloseUserMenu}
        >
          <div className="row p-1 pb-0">
            <MenuItem
              className="border-bottom border-1 p-3 pb-0 d-flex"
              onClick={(e) => this.profileHandler(e)}
            >
              <div className="col-md-2 text-center align-self-start mt-1 ps-1">
                <Avatar
                  sx={{
                    bgcolor: "#337ab7",
                    color: "#fff",
                    width: 35,
                    height: 35,
                    fontSize: 16,
                    fontWeight: "500",
                  }}
                >
                  {Utils.getShortName(userName)}
                </Avatar>
              </div>
              <div className="col-md-10 ps-2">
                <p className="mb-0" style={{ fontSize: "16px" }}>
                  {`${this.appuser?.firstName} ${this.appuser?.lastName}`}
                </p>
                <p className="mb-0" style={{ fontSize: "12px" }}>{this.appuser?.email}</p>
                <p style={{ fontSize: "12px" }}>Customer ID: {this.appuser?.organization?.customerUid}</p>
              </div>
            </MenuItem>
            <MenuItem
              className="border-bottom border-1 justify-content-start ps-3 p-0"
              onClick={this.logOut.bind(this)}
            >
              <div className="col-md-12 p-2"><LogoutIcon style={{ fontSize: "large" }} /> Sign out</div>
            </MenuItem>
          </div>
        </Menu>
        <Menu
          className="userMenu"
          sx={{ mt: "40px", zIndex: "10000" }}
          id="menu-appbar"
          anchorEl={this.state.openCreditUsage}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          // keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(this.state.openCreditUsage)}
          onClose={this.handleCloseCreditUsage}
        >
          <div className="row p-2" style={{ width: "370px" }}>
            <div className="col-md-12" style={{ fontSize: "12px" }}>
              <p>
                Your account includes{" "}
                {Utils.formatWithCommas(this.organizationPlan?.smsCredits)} text
                credits per{" "}
                {Utils.getPlanType(this.organizationPlan?.planType?.type)}.{" "}
              </p>{" "}
              <p className="mb-0">
                {" "}
                <span
                  className="anchortag"
                  onClick={(e) => this.goBillingTab(e, true)}
                >
                  Add a credit card now{" "}
                </span>
                so if you reach the maximum limit, messaging will not stop working.
              </p>
            </div>
          </div>
        </Menu>
        <Menu
          className="userMenu"
          sx={{ mt: "40px", zIndex: "10000" }}
          id="menu-appbar"
          anchorEl={this.state.openOverages}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          // keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(this.state.openOverages)}
          onClose={this.handleCloseOverages}
        >
          <div className="row p-2" style={{ width: "370px" }}>
            <div className="col-md-12" style={{ fontSize: "12px" }}>
              <p>
                Your account is limited to{" "}
                {Utils.formatWithCommas(this.organizationPlan?.smsCredits)} text
                credits per{" "}
                {Utils.getPlanType(this.organizationPlan?.planType?.type)}.{" "}
                Once this amount is reached, additional text messages will not go through.
              </p>{" "}
              <p className="mb-0">
                A request to {" "}
                <span
                  className="anchortag cursor-pointer"
                  onClick={this.sendRemoveOverageLimitToBackend.bind(this)}
                >
                  remove the limit{" "}
                </span>
                can take up to 48 hours.
              </p>
            </div>
          </div>
        </Menu>
        <Menu
          className="userMenu"
          sx={{ mt: "40px", zIndex: "10000" }}
          id="menu-appbar"
          anchorEl={this.state.unverifiedOpen}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          // keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(this.state.unverifiedOpen)}
          onClose={this.handleUnverifiedClose.bind(this)}
        >
          <div className="row p-2" style={{ width: "365px" }}>
            <div className="col-md-12" style={{ fontSize: "12px" }}>
              <p className="mb-0 p-2">
                Your texting number has not yet been verified by the carriers.
                Until then, you can create messages and manage groups but it is
                not possible to send texts.
              </p>
            </div>
          </div>
        </Menu>
        <Dialog
          open={this.state.downloadAppOpen}
          onClose={this.handleDownloadAppDialogClose.bind(this)}
          style={{ padding: "1em" }}
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>Download GivBee EventText app</span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleDownloadAppDialogClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <DialogContent style={{ background: "#f2f5f9 " }}>
            <div className="row p-4">
              <div className="col-sm-6">
                <div className="row justify-content-center">
                  <div
                    className="col-sm-10"
                    style={{
                      textAlign: "center",
                      background: "#fff",
                      borderRadius: "25px",
                      padding: "10px 0px",
                    }}
                  >
                    <a
                      style={{ color: "#fff", cursor: "pointer" }}
                      href="https://apps.apple.com/us/app/givbee-eventtext-2-0/id6741511876"
                      target="_blank"
                    >
                      <img
                        src={AppleStore}
                        style={{
                          height: "45px",
                          width: "180px",
                          border: "1px solid white",
                          borderRadius: "5px",
                          objectFit: "contain",
                        }}
                      />
                      <img
                        src={AppleStoreQRCode}
                        style={{
                          height: "180px",
                          border: "1px solid white",
                          borderRadius: "5px",
                          objectFit: "contain",
                        }}
                      />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="row justify-content-center">
                  <div
                    className="col-sm-10"
                    style={{
                      textAlign: "center",
                      background: "#fff",
                      borderRadius: "25px",
                      padding: "10px 0px",
                    }}
                  >
                    <a
                      target="_blank"
                      href="https://play.google.com/store/apps/details?id=com.app.givbeeapp"
                      style={{ color: "#fff", cursor: "pointer" }}
                    >
                      <img
                        src={GooglePlayStore}
                        style={{
                          height: "50px",
                          width: "180px",
                          border: "1px solid white",
                          borderRadius: "5px",
                          objectFit: "contain",
                        }}
                      />
                      <img
                        src={AndroidStoreQRCode}
                        style={{
                          height: "180px",
                          border: "1px solid white",
                          borderRadius: "5px",
                        }}
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
        <Dialog
          open={this.state.open}
          onClose={this.handleDialogboxClose.bind(this)}
          style={{ padding: "1em" }}
        >
          <DialogContent>
            <Row style={{ marginRight: "auto", marginLeft: "auto" }}>
              <Col md={12} style={{ textAlign: "center" }}>
                <ErrorOutlineIcon
                  style={{
                    border: "2px solid #fff",
                    borderRadius: "25%",
                    background: "#066f72 !important",
                    color: "red",
                    fontSize: "50px",
                  }}
                />
              </Col>
            </Row>
            <span style={{ textAlign: "center" }}>
              <h2 style={{ fontSize: "20px" }}>
                Looks like you haven't uploaded a logo yet!…Do you want to set
                it now?
              </h2>
            </span>
          </DialogContent>
          <DialogActions
            style={{
              // marginTop: "1em",
              padding: "2em",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <a
              className="me-0"
              href="#logo"
              onClick={this.organizationInfo.bind(this)}
            >
              <Button
                variant="contained"
                size="large"
                style={{
                  background: "#37517e",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "5px 16px",
                }}
                startIcon={<SaveIcon />}
              // onClick={this.organizationInfo.bind(this)}
              >
                Yes
              </Button>
            </a>
            <Button
              variant="contained"
              size="large"
              style={{
                background: "#717373",
                color: "#fff",
                marginRight: "1rem",
                padding: "2px 10px",
                textTransform: "capitalize",
              }}
              startIcon={<CloseIcon />}
              onClick={this.handleDialogboxClose.bind(this)}
            >
              Maybe Later
            </Button>
          </DialogActions>
        </Dialog>

        {
          this.state.istollfreeNumberPurchased && (
            <UsecaseDialog
              ref={this.usecaseDialogueRef}
              style={{ float: "right" }}
            />
          )
        }
        {/* <Dialog
          open={this.state.istollfreeNumberPurchased}
          onClose={this.tollfreeNumberPurchasedToggle.bind(this)}
          style={{ padding: "1em" }}
        >
          <DialogContent style={{ marginTop: "1em" }}>
            <Row>
              <Col md={12} style={{ textAlign: "justify" }}>
                <div
                  className="text-start text-align-justify tollFreeNumberError"
                  dangerouslySetInnerHTML={{
                    __html: this.tollFreeNumberError
                      ? this.tollFreeNumberError
                      : "",
                  }}
                ></div>
              </Col>
            </Row>
          </DialogContent>
          <DialogActions
            style={{
              padding: "1em",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <Button
              variant="contained"
              size="small"
              style={{
                // float: 'right',
                background: "#ef6603",
                color: "#fff",
              }}
              onClick={this.addTollFreeNumberModal.bind(this)}
            >
              Finish Setup
            </Button>
          </DialogActions>
        </Dialog> */}

        <Dialog open={this.state.openTnCModal} style={{ padding: "1em" }}>
          <DialogContent style={{ overflowY: "hidden" }}>
            <Row>
              <Col md={12}>
                <span
                  style={{
                    color: "#162c50",
                    // margin: "1.1em 1em",
                    // padding: "1em",
                  }}
                >
                  We have updated our Terms & Conditions and Privacy Policy.
                  <br />
                  Please review and accept before proceeding.
                </span>{" "}
                <br /> <br />
                <span
                  className="TandCPPCheckbox"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "#162c50",
                    gap: "6px",
                  }}
                >
                  <input
                    id="checkboxTNC"
                    type="checkbox"
                    checked={this.state.checkboxTNC}
                    onChange={this.handleTAndCClickCheckBox}
                    style={{ cursor: "pointer" }}
                  />

                  <label htmlFor="checkboxTNC" style={{ cursor: "pointer" }}>
                    I accept the{" "}
                  </label>

                  <a
                    href="/terms-conditions"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#007bff", fontWeight: 600, fontSize: "14px" }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <u>Terms & Conditions</u>
                  </a>

                  <label htmlFor="checkboxTNC" style={{ cursor: "pointer" }}>
                    {" "}and{" "}
                  </label>

                  <a
                    href="/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#353538" }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <u style={{ color: "#007bff", fontWeight: 600, fontSize: "14px" }}
                    >Privacy Policy</u>.
                  </a>
                </span>
              </Col>
            </Row>
          </DialogContent>
          <DialogActions
            style={{
              padding: "1em",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            {this.state.checkboxTNC && this.state.checkboxTNC === true ? (
              <Button
                variant="contained"
                size="small"
                style={{
                  // float: 'right',
                  background: "#ef6603",
                  color: "#fff",
                }}
                onClick={(e) => this.acceptTandCtInBackend(e)}
              >
                Accept
              </Button>
            ) : (
              <Button
                variant="contained"
                size="small"
                disabled
                style={{
                  // float: 'right',
                  opacity: "0.5",
                  background: "#ef6603",
                  color: "#fff",
                }}
                onClick={(e) => this.acceptTandCtInBackend(e)}
              >
                Accept
              </Button>
            )}
            &nbsp;
            <Button
              variant="contained"
              size="small"
              style={{
                background: "#717373",
                color: "#fff",
                marginRight: "1rem",
              }}
              // startIcon={<CloseIcon />}
              onClick={this.tnCModalToggle.bind(this)}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.openCardExpiredModal}
          onClose={this.cardExpiredCancel.bind(this)}
          // onHide={this.close}
          style={{ padding: "1em" }}
        >
          <DialogContent style={{ marginTop: "1em", overflowY: "hidden" }}>
            <Row>
              <Col md={12} style={{ textAlign: "center" }}>
                <span
                  style={{
                    color: "#162c50",
                    margin: "1.1em 1em",
                    padding: "1em",
                  }}
                >
                  {(this.appuser.profile?.name === "Admin" || this.header.isAp) ? "Credit card update required. To keep this account active, please update the card on file or add a new card." : "Credit card update required. To keep this account active, please have an Admin user update the card on file or add a new card."}
                </span>
              </Col>
            </Row>
          </DialogContent>
          <DialogActions
            style={{
              padding: "1em",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            {(this.appuser.profile?.name === "Admin" || this.header.isAp) &&
              <>
                <Button
                  variant="contained"
                  size="small"
                  style={{
                    // float: 'right',
                    background: "#ef6603",
                    color: "#fff",
                    textTransform: "none",
                  }}
                  onClick={(e) => this.handleUpdateCardClick(e)}
                >
                  Update Card
                </Button>
                &nbsp;
              </>
            }
            < Button
              variant="contained"
              size="small"
              style={{
                background: "#717373",
                color: "#fff",
                marginRight: "1rem",
                textTransform: "none",
              }}
              // startIcon={<CloseIcon />}
              onClick={this.cardExpiredCancel.bind(this)}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog >
        {/* <Dialog
          open={this.state.openCardExpiringModal}
          onClose={this.cardExpiringCancel.bind(this)}
          // onHide={this.close}
          style={{ padding: "1em" }}
        >
          <DialogContent style={{ marginTop: "1em", overflowY: "hidden" }}>
            <Row>
              <Col md={12} style={{ textAlign: "center" }}>
                <span
                  style={{
                    color: "#162c50",
                    margin: "1.1em 1em",
                    padding: "1em",
                  }}
                >
                  {`Please update new Credit card information in ‘Account Settings
                  > Billing’ tab`}
                </span>
              </Col>
            </Row>
          </DialogContent>
          <DialogActions
            style={{
              padding: "1em",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <Button
              variant="contained"
              size="small"
              style={{
                // float: 'right',
                background: "#ef6603",
                color: "#fff",
                textTransform: "none",
              }}
              onClick={(e) => this.goBillingTab(e, true)}
            >
              Ok
            </Button>
            &nbsp;
            <Button
              variant="contained"
              size="small"
              style={{
                background: "#717373",
                color: "#fff",
                marginRight: "1rem",
                textTransform: "none",
              }}
              // startIcon={<CloseIcon />}
              onClick={this.cardExpiringCancel.bind(this)}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog> */}
        < Dialog
          open={this.state.openHasActiveSubscription}
          onClose={this.hasActiveSubscriptionCancel.bind(this)}
          style={{ padding: "1em" }
          }
        >
          <DialogContent style={{ marginTop: "1em", overflowY: "hidden" }}>
            <Row>
              <Col md={12} style={{ textAlign: "center" }}>
                <span
                  style={{
                    color: "#162c50",
                    margin: "1.1em 1em",
                    padding: "1em",
                  }}
                >
                  Please update credit card information to continue
                  subscription.
                </span>
              </Col>
            </Row>
          </DialogContent>
          <DialogActions
            style={{
              padding: "1em",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <Button
              variant="contained"
              size="small"
              style={{
                // float: 'right',
                background: "#ef6603",
                color: "#fff",
                textTransform: "none",
              }}
              onClick={(e) => this.goBillingTab(e, false)}
            >
              Ok
            </Button>
            &nbsp;
            <Button
              variant="contained"
              size="small"
              style={{
                background: "#717373",
                color: "#fff",
                marginRight: "1rem",
                textTransform: "none",
              }}
              // startIcon={<CloseIcon />}
              onClick={this.hasActiveSubscriptionCancel.bind(this)}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog >
        <Dialog
          open={this.state.openHasActiveCard}
          onClose={this.hasActiveCardCancel.bind(this)}
          // onHide={this.close}
          style={{ padding: "1em" }}
        >
          <DialogContent style={{ marginTop: "1em", overflowY: "hidden" }}>
            <Row>
              <Col md={12} className="text-c">
                <p>
                  {`Hi ${this.appuser?.firstName} ${this.appuser?.lastName}`},
                </p>
                <p>
                  Your texting plan is capped at {" "}
                  {Utils.formatWithCommas(this.organizationPlan?.smsCredits)}{" "}
                  text credits per{" "}
                  {Utils.getPlanType(this.organizationPlan?.planType?.type)}.{" "}
                </p>{" "}
                <p>
                  {" "}
                  If you reach this amount additional texts cannot be sent until the new {" "} {Utils.getPlanType(this.organizationPlan?.planType?.type)} starts.
                </p>
                <p>
                  If you want the option to exceed the cap, a credit card must be added. Text overages will be charged at ${Utils.formatWithCommas(this.organizationPlan?.overagesRate)}{" "} per block of {" "}
                  {Utils.formatWithCommas(
                    this.organizationPlan?.overagesBlocksize
                  )}.
                </p>
                <div className="row justify-content-center mt-4">
                  <div className="col-sm-12">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "12px",
                        flexWrap: "wrap",
                      }}
                    >
                      <Button
                        variant="contained"
                        type="button"
                        size="small"
                        style={{
                          width: "140px",
                          background: "#ef6603",
                          color: "#fff",
                          textTransform: "none",
                        }}
                        onClick={(e) => this.goBillingTab(e, true)}
                      >
                        Add a Card
                      </Button>

                      <Button
                        variant="contained"
                        size="small"
                        style={{
                          width: "120px",
                          background: "#717373",
                          color: "#fff",
                          textTransform: "none",
                        }}
                        onClick={this.hasActiveCardCancel.bind(this)}
                      >
                        Close
                      </Button>

                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          id="assignToGroup"
                          type="checkbox"
                          style={{ cursor: "pointer" }}
                          checked={this.state.stopCardExpiryMessage}
                          onChange={this.handleStopCardExpiryMessageChange}
                        />
                        <label
                          htmlFor="assignToGroup"
                          className="ms-1 mb-0"
                          style={{ cursor: "pointer", fontSize: "13px" }}
                        >
                          Don't show again
                        </label>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <p>Questions? Contact us here:
                    <a
                      className="anchortag ms-1"
                      href={`mailto: support@dptext.org`}
                      rel="noopener noreferrer"
                    >
                      support@dptext.org.
                    </a>
                  </p>
                </div>
              </Col>
            </Row>
          </DialogContent>
          {/* <DialogActions
            style={{
              padding: "1em",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <Button
              variant="contained"
              type="button"
              size="small"
              style={{
                // float: 'right',
                background: "#ef6603",
                color: "#fff",
                textTransform: "none",
              }}
              onClick={(e) => this.goBillingTab(e, true)}
            >
              Add a Card
            </Button>
            &nbsp;
            <Button
              variant="contained"
              size="small"
              style={{
                background: "#717373",
                color: "#fff",
                marginRight: "1rem",
                textTransform: "none",
              }}
              // startIcon={<CloseIcon />}
              onClick={this.hasActiveCardCancel.bind(this)}
            >
              Close
            </Button>
            <span
              className="anchortag"
              onClick={(e) => this.goBillingTab(e, true)}
            >
              Don't show again
            </span>
          </DialogActions> */}
        </Dialog>
        <Modal
          isOpen={this.state.menuList}
          toggle={this.menuListToggle}
          size="sm"
          style={{ marginTop: "5em" }}
        >
          <Row>
            <Col md={12}>
              <CloseIcon
                onClick={(e) => this.menuListToggle()}
                style={{ float: "right", margin: "0.5em 1em 0em 0em" }}
              />
            </Col>
          </Row>
          <ModalBody style={{ padding: "0.5em" }}>
            <nav className="mobileViewTopNav">
              <ul className="p-1" style={{ backgroundColor: "#fff" }}>
                {this.state.sidebarMenu
                  ?.sort((a, b) => a.displaysequence - b.displaysequence)
                  .map((menu) => {
                    if (menu.isactive !== true) return null;
                    const isOpen = menu.pageid === this.state.activeMenu;
                    const showChildMenus = menu.uiname === "All Events"
                    return (
                      <li key={menu.id} className="mb-1">
                        <NavLink
                          to={menu.pageid}
                          className="menu-link"
                          style={{
                            background: isOpen ? "#37517e" : "#d3d8de",
                            color: isOpen ? "#fff" : "#000",
                            borderRadius: "10px",
                          }}
                          onClick={(e) =>
                            this.getChildMenus(e, menu.id, menu.pageid)
                          }
                        >
                          <div className="p-2 ps-3 text-center">
                            {menu.uiname}
                          </div>
                        </NavLink>

                        {showChildMenus && menu.childMenus?.length > 0 && (
                          <ul className="mt-1 ps-3">
                            {menu.childMenus.map((child) => (
                              <li key={child.id} className="mb-1">
                                <NavLink
                                  to={child.pageid}
                                  className="menu-link"
                                  style={{
                                    background: "#eef1f5",
                                    color: "#000",
                                    borderRadius: "8px",
                                    fontSize: "0.9rem",
                                  }}
                                  onClick={(e) =>
                                    this.goToPage(e, child.id, child.pageid)
                                  }
                                >
                                  <div className="p-2">
                                    {child.uiname}
                                  </div>
                                </NavLink>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    );
                  })}
              </ul>
            </nav>
          </ModalBody>
        </Modal>

        < Dialog
          open={this.state.sendRemoveOverageLimitOpen}
          onClose={this.handleCloseSendRemoveOverageLimit.bind(this)}
          style={{ padding: "1em" }
          }
        >
          <DialogContent style={{ marginBottom: "10px", overflowY: "hidden" }}>
            <Row>
              <Col md={12} style={{ textAlign: "center" }}>
                <span
                  style={{
                    color: "#162c50",
                    margin: "1.1em 1em",
                    padding: "1em",
                  }}
                >
                  An email is send to support team. Someone will contact you soon.
                </span>
              </Col>
            </Row>
          </DialogContent>
        </Dialog >
      </>
    );
  }
}

// export default withRouter(Navbar);
// const mapStateToProps = (state) => {
//   console.log(state);
//   return {
//     smsCredits: state.appUserData.smsCredits,
//     logoData: state.appUserData.logoData.logo,
//     companyName: store.getState().appUserData?.organizationDetails?.name,
//   };
// };
// const MyComponent = connect(mapStateToProps)(Navbar);
export default withRouter(Navbar);  
